import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  day: 'Día 1',
  title: 'Diagnóstico y Cierre',
  desc: 'Implementas la Regla 3-2-1 para preparar tu sistema nervioso antes del atardecer.'
}, {
  day: 'Noche 1',
  title: 'Ejecución del Bloqueo',
  desc: 'Aplicas el Vaciado de Caja Negra y la técnica de conteo cognitivo al acostarte.'
}, {
  day: 'Día 3',
  title: 'Optimización Biológica',
  desc: 'Ajustas tu entorno térmico y notarás cómo tu energía matutina regresa por primera vez en años.'
}];
export function HowItWorks() {
  return <section className="w-full bg-midnight-deep py-24 px-6 border-y border-cyan-signal/10" data-id="element-98">
      <div className="max-w-6xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-100">
          <h2 className="font-display text-3xl md:text-5xl text-bone uppercase leading-tight" data-id="element-101">
            El Protocolo de 72 Horas
          </h2>
        </motion.div>

        <div className="relative" data-id="element-102">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-px bg-cyan-signal/30 z-0" data-id="element-103" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-104">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-105">
                <div className="w-24 h-24 bg-midnight border-2 border-cyan-signal flex items-center justify-center mb-8 shadow-[0_0_20px_rgba(61,169,252,0.15)]" data-id="element-106">
                  <span className="font-display text-3xl text-cyan-signal uppercase" data-id="element-107">
                    {step.day}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-bone mb-4 uppercase tracking-wide" data-id="element-108">
                  {step.title}
                </h3>
                <p className="text-steel leading-relaxed" data-id="element-109">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}